import React from "react"
import { useParams, useLocation } from "react-router"
import styled from "styled-components"
import theme from "theme"

import { Box } from "components/box"
import { Link } from "components/text"

import { LearnSections } from "pages/learn/learn-types"
import { Params } from "./post-summary-list"
import { FontConfigurations } from "theme"

const Container = styled(Box)`
  text-align: center;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;

  border-top: 1px solid ${props => props.theme.colors.silver};
  border-bottom: 1px solid ${props => props.theme.colors.silver};
`
const activeStyle = { borderBottom: `${theme.space[1]} solid ${theme.colors.evergreen}` }

const SectionTitle = styled(Link).attrs({
  py: 4,
  mx: 5,
  ...FontConfigurations.h5,
  activeStyle
})<{ active?: boolean }>`
  ${props => props.active && activeStyle};

  display: inline-block;
  white-space: nowrap;
`

export const SectionsPanel = () => {
  const { pathname } = useLocation()
  const { page, section } = useParams<Params>()

  const hasPage = page || !isNaN(Number(section))

  return (
    <Container>
      <SectionTitle
        to={hasPage ? "/learn/1" : "/learn"}
        exact
        active={pathname.includes("learn") && !pathname.includes("section")}
      >
        View all
      </SectionTitle>
      {Object.keys(LearnSections).map(section => (
        <SectionTitle
          key={section}
          active={pathname.includes("section") && pathname.includes(section)}
          to={hasPage ? `/learn/section/${section}/1` : `/learn/section/${section}`}
        >
          {LearnSections[section as keyof typeof LearnSections]}
        </SectionTitle>
      ))}
    </Container>
  )
}
